<template>
  <div :class="classnames">
    <template v-if="this.$slots.default">
      <node-decorator :focusedTabId="focusedTabId">
        <node-filterer :nodes="this.$slots.default" :render="['tabs-nav-item']" />
      </node-decorator>
    </template>
  </div>
</template>

<script>
  import NodeDecorator from '@/components/NodeDecorator'
  import NodeFilterer from '@/components/NodeFilterer'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'tabs-nav'

  export default {
    name: 'TabsNav',
    components: {
      'node-decorator': NodeDecorator,
      'node-filterer': NodeFilterer
    },
    mixins: [ bem ],
    data: function () {
      const {
        focusedTabId
      } = this.$parent

      return {
        focusedTabId
      }
    },
    created: function () {
      this.namespace = namespace
    },
    mounted: function () {
      this.initialize()
    },
    methods: {
      handleNavItemClick: function () {
        const self = this

        this.$children.forEach(function ($child) {
          $child.$on('click', function (id) {
            self.$emit('click', id)
          })
        })
      },
      handleTabsFocus: function () {
        const self = this

        this.$parent.$on('focus', function (id) {
          self.setFocusedTabId(id)
        })
      },
      initialize: function () {
        this.handleNavItemClick()

        this.handleTabsFocus()
      },
      setFocusedTabId: function (id) {
        this.focusedTabId = id
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Tabs/TabsNav.vue